import React from 'react'
import PropTypes from 'prop-types'
import styles from './numberInput.css'
import sanitizeText from './helpers/sanitizeText'
import sanitizeNumber from './helpers/sanitizeNumber'
import formatNumber from './helpers/formatNumber'

class NumberInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: 0
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  componentWillMount () {
    const defaultValue = this.props.value || this.props.min.toString() || '0'
    this.writeValueToInput(defaultValue, { silent: true })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.value) {
      this.writeValueToInput(nextProps.value, { silent: true })
    }
  }

  handleChange ({ target: { value } }) {
    const newValue = sanitizeText(value, this.props)
    this.setValue(newValue)
  }

  handleFocus ({ target }) {
    const newState = sanitizeNumber(target.value, this.props)
    newState.value = formatNumber(newState.value, this.props)
    this.setState(newState, () => {
      if (this.props.selectOnFocus) {
        target.select()
      }
    })
  }

  handleBlur ({ target: { value } }) {
    const { max, min, name } = this.props

    if (value > max || value < min) {
      value = this.refs[name].value
    }

    this.writeValueToInput(value, true)
  }

  writeValueToInput (value, { silent = false }) {
    const newState = sanitizeNumber(value, this.props)
    newState.value = formatNumber(newState.value, this.props)
    this.setValue(newState.value, silent)
  }

  setValue (value, silent) {
    this.setState({ value }, () => {
      if (this.props.onChange && !silent) {
        this.props.onChange(value)
      }
    })
  }

  render () {
    const {
      inputClass,
      className,
      name,
      disabled,
      placeholder
    } = this.props

    return (
      <div className={`${className ? className : ''}`}>
        <input
          className={`${styles.input} ${inputClass}`}
          type="text"
          value={this.state.value}
          name={name}
          ref={name}
          disabled={disabled}
          placeholder={placeholder}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        <span className={styles.bar}/>
      </div>
    )
  }
}

NumberInput.propTypes = {
  value: PropTypes.number,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  precision: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  decimal: PropTypes.string,
  thousand: PropTypes.string,
  format: PropTypes.string,
  selectOnFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  inputClass: PropTypes.string
}

NumberInput.defaultProps = {
  value: 0,
  name: '',
  placeholder: '',
  precision: 2,
  min: NaN,
  max: NaN,
  decimal: ',',
  thousand: '',
  format: '%v %s',
  selectOnFocus: false,
  disabled: false,
  className: '',
  inputClass: ''
}

export default NumberInput



// WEBPACK FOOTER //
// ./src/components/inputs/numberInput.jsx